import { Box, Container, Grid, Typography } from "@mui/material";
import { Sectional } from "layout/Sectional";
import Splash from "layout/Splash";
import React from "react";
import { Label, Pie, PieChart } from "recharts";

type PlayableExhibit = {
    name: string,
    status: string,
    image: string,
    description: string,
    bonus_fact: string
}

type ExhibitsProperties = {
    exhibits: PlayableExhibit[]
}

export const ExhibitsWidget: React.FC<ExhibitsProperties> = ({ exhibits }) => {
    // Filter exhibits with status "Playable"
    const playableExhibits = exhibits.filter(exhibit => exhibit.status === "Playable");
    
    return (
        <Container>
            <Grid container spacing={2}>
                {playableExhibits.map((exhibit) => (
                    <Grid item xs={12} md={6} key={exhibit.name}>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                paddingTop: "50px",
                                height: "100%",
                            }}
                        >
                            <Typography variant="h6" gutterBottom>
                                {exhibit.name}
                            </Typography>
                            {exhibit.image && (
                                <img
                                    src={exhibit.image}
                                    alt={exhibit.name}
                                    style={{ maxWidth: "100%", height: "auto" }}
                                />
                            )}
                            <Typography sx={{ marginTop: 2 }}>
                                {exhibit.description}
                            </Typography>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

/*
export const ExhibitsWidget: React.FC<ExhibitsProperties> = ({ exhibits }) => {
    return (
        <>
            {
                exhibits.map((exhibit) => {
                    return (
                        <Sectional title={ exhibit.name }>
                            <Grid container spacing={2}>
                                <Grid item sm={5}>
                                    { exhibit.description }
                                </Grid>
                                <Grid item sm={7}>
                                    <Box sx={{ width: "100%"}} component="img" src={ exhibit.image }></Box>
                                </Grid>
                            </Grid>
                        </Sectional>
                    )
                })
            }
        </>
    );
}
*/
